import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import type { RootState } from '../../app/store'
import type { MealT } from '../../models/menus'
import type { DeliveryT } from '../../models/cart'
import { getFormattedPriceByDeliveryType } from '../../utils/formattedPrice'
import Arrow from '../../icons/Arrow'
import styles from './MealItem.module.css'

type PropsT = {
  meal: MealT,
  href: string,
  deliveryType: DeliveryT
}

function MealItem ({ href, meal, deliveryType }: PropsT) {
  const { name, description, image } = meal

  return (
    <li className={styles.item}>
      <Link className={styles.itemContent} to={href}>
        <>
          {image && (
            <div className={styles.imageContainer}>
              <img className={styles.image} src={image} alt={`Produktbild ${name}`} />
            </div>
          )}
          <div className={styles.text}>
            <h3 className={styles.heading}>{name}</h3>
            <p className={styles.description}>{description}</p>
          </div>
          <div className={styles.rightContent}>
            <span className={styles.price}>{getFormattedPriceByDeliveryType(meal, deliveryType)}</span>
            <Arrow className={styles.icon} direction="right" color="#cf2e05" />
          </div>
        </>
      </Link>
    </li>
  )
}

function mapState(state: RootState) {
  return {
    deliveryType: state.cart.deliveryType,
  };
}

export default connect(mapState)(MealItem)